import React from "react";
import Header from "../component/Header";
import Footer from "../component/Footer";
import ExploreResultLocations from "../component/ExploreResultLocations";
import BecomeAgentBanner from "../component/BecomeAgentBanner";
import CreateAccountCTA from "../component/CreateAccountCTA";
import { Col, Container, Row } from "react-bootstrap";
import BecomeAgentIcon1 from "../assets/images/become-agent-icon-1.svg";
import BecomeAgentIcon2 from "../assets/images/become-agent-icon-2.svg";
import BecomeAgentIcon3 from "../assets/images/become-agent-icon-3.svg";
import { usePageContent } from "../hooks/usePageContent";
import { ASSETS_URL } from "../api/constants"; // adjust to your image base URL
import { Helmet } from "react-helmet-async";

function BecomeAgent() {
  const { content, loading } = usePageContent("become-an-agent");

  const section = React.useMemo(() => {
    try {
      return content?.become_an_agent_section
        ? JSON.parse(content.become_an_agent_section)
        : null;
    } catch {
      return null;
    }
  }, [content]);

  const img = (path) => (path ? `${ASSETS_URL}/${path}` : null);

  const contentSections = section
    ? [
        {
          image: img(section.section_2?.image),
          icon: img(section.section_2?.icon) || BecomeAgentIcon1,
          title: section.section_2?.title,
          subtitle: section.section_2?.subtitle,
          textSide: "right",
        },
        {
          image: img(section.section_3?.image),
          icon: img(section.section_3?.icon) || BecomeAgentIcon2,
          title: section.section_3?.title,
          subtitle: section.section_3?.subtitle,
          textSide: "left",
        },
        {
          image: img(section.section_4?.image),
          icon: img(section.section_4?.icon) || BecomeAgentIcon3,
          title: section.section_4?.title,
          subtitle: section.section_4?.subtitle,
          textSide: "right",
        },
      ]
    : [];

  return (
    <>
      <Helmet>
        <title>{`${content?.page_name || "Become An Agent"} | Jambobay`}</title>
        <meta
          name="description"
          content="Learn how to become a Jambobay agent and grow your real estate business."
        />
        <meta
          name="keywords"
          content="Become An Agent, Jambobay, Real Estate Agent, Partner, Career"
        />
      </Helmet>
    <div className="main become-agent-page">
      <Header />
      <BecomeAgentBanner data={section?.section_1} bannerImage={img(section?.section_1?.image)} />
      <div className="become-agent-content common-padding">
        <Container>
          <Row className="row-gap-100 align-items-center">
            {contentSections.map((sec, i) => {
              const imageCol = (
                <Col md={12} lg={6} key={`img-${i}`}>
                  <div className="become-agent-img">
                    {sec.image && <img src={sec.image} alt={sec.title} />}
                  </div>
                </Col>
              );
              const textCol = (
                <Col md={12} lg={6} key={`text-${i}`}
                  className={sec.textSide === "left" ? "order-2 order-lg-0" : ""}
                >
                  <div className={`become-agent-text ${sec.textSide === "right" ? "pl-25" : "pr-25"}`}>
                    <div className="become-agent-icon">
                      <img src={sec.icon} alt="" />
                    </div>
                    <h2 dangerouslySetInnerHTML={{ __html: sec.title }} />
                    <p>{sec.subtitle}</p>
                  </div>
                </Col>
              );

              return sec.textSide === "right"
                ? [imageCol, textCol]
                : [textCol, imageCol];
            })}
          </Row>
        </Container>
      </div>
      <CreateAccountCTA data={section?.section_5} />
      <ExploreResultLocations />
      <Footer />
    </div>
    </>
  );
}

export default BecomeAgent;